var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15.188A7.594,7.594,0,1,0,5.906,7.594,7.6,7.6,0,0,0,13.5,15.188Zm6.75,1.687H17.344a9.18,9.18,0,0,1-7.689,0H6.75A6.749,6.749,0,0,0,0,23.625v.844A2.532,2.532,0,0,0,2.531,27H24.469A2.532,2.532,0,0,0,27,24.469v-.844A6.749,6.749,0,0,0,20.25,16.875Z",
    transform: "translate(1 1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHeader);
export default __webpack_public_path__ + "static/media/profile-header.b6bd4bd4ee63168c81f62b285d7a6c32.svg";
export { ForwardRef as ReactComponent };